import React, {useEffect, useMemo, useState} from 'react';
import {
    DatePickerCustom,
    InputEntidad,
    InputFormat,
    InputLista,
    InputNumber,
    Accordion,
    FormError,
    FormLabel,
} from '../../../../components/common';
import {getDateNow} from '../../../../utils/convert';
import DataTaggerFormRedux from '../../../../components/controls/DataTaggerFormRedux';
import DomiciliosGrid from '../../../../components/controls/DomiciliosGrid';
import InhumadosGrid from '../../../../components/controls/InhumadosGrid';
import VinculosCementerioGrid from '../../../../components/controls/VinculosCementerioGrid';
import { ALERT_TYPE, CUENTA_STATE, MASK_FORMAT, OPERATION_MODE, PATTERNS, ShowToastMessage } from '@laramie/ui';
import {MakeListDomicilios} from '../../utils';
import {ElementosTab, TabsForm} from './components';
import {isEmptyString} from '../../../../utils/validator';
import InputSecret from '../../../../components/common/InputSecret';
import {PRESTADOR_CEMENTERIO_TYPE} from '../../../../consts/PrestadorCementerioType';
import {usePermissions} from '../../../../components/hooks/usePermissions';
import {PERMISSIONS} from '../../../../consts/permissions';
import {TIPS} from "../../../../consts/tips";

const SectionForm = ({
                         SetTabActive,
                         setPendingChange,
                         state,
                         cementerio_formValues,
                         cementerio_formHandleProxy,
                         cementerio_formSet,
                         cuenta_formValues,
                         cuenta_formHandleProxy,
                         UpdateEntity,
                         handleClickBaja,
                         tipoConstruccionFuneraria,
                         setTipoConstruccionFuneraria,
                         ubicacionDefinicion,
                         errorOf,
                         cuentaOpen,
                         setCuentaOpen,
                         sepulturaOpen,
                         setSepulturaOpen,
                         ubicacionOpen,
                         setUbicacionOpen,
                         estadoOpen,
                         setEstadoOpen,
                         pendingChange,
                         refetchCementerio
                     }) => {

    const [domicilios, setDomicilios] = useState([]);

    const today = useMemo(() => getDateNow(), []);

    const {hasPermission} = usePermissions();
    const canEditPersonasVinculadas = hasPermission(PERMISSIONS.PERSONAS_VINCULADAS_EDIT);
    const canEditInhumados = hasPermission(PERMISSIONS.INHUMADO_EDIT);

    useEffect(() => {
        if (state.entity.zonasEntrega.length > 0 || state.entity.vinculosCementerio.length > 0) {
            MakeListDomicilios(state)
                .then(response => {
                    setDomicilios(response);
                })
                .catch(error => {
                    const message = error.message;
                    ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                    setDomicilios([]);
                });
        } else {
            if (domicilios.length > 0) setDomicilios([]);
        }
    }, [state.entity.zonasEntrega, state.entity.vinculosCementerio])

    return (
        <>
            <section className='section-accordion'>
                <div className="m-top-20 m-bottom-20">
                    <Accordion title="Cuenta" open={cuentaOpen} onToggle={setCuentaOpen}>
                        <div className='row form-basic'>
                            <div className="col-12 col-md-3 col-lg-2">
                                <label htmlFor="cuenta_numeroCuenta" className="form-label">Número de cuenta</label>
                                <InputFormat
                                    name="cuenta_numeroCuenta"
                                    placeholder="[autonumérico]"
                                    className="form-control"
                                    mask={MASK_FORMAT.CUENTA}
                                    maskPlaceholder={null}
                                    value={cuenta_formValues.numeroCuenta}
                                    onChange={cuenta_formHandleProxy}
                                    disabled={true}
                                />
                                <FormError />
                            </div>
                            <div className="col-6 col-md-4 col-lg-2">
                                <label htmlFor="cuenta_numeroWeb" className="form-label">Clave web</label>
                                <InputSecret
                                    name="cuenta_numeroWeb"
                                    mask={MASK_FORMAT.CLAVE_WEB}
                                    maskPlaceholder={null}
                                    value={cuenta_formValues.numeroWeb}
                                    onChange={cuenta_formHandleProxy}
                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                />
                                <FormError />
                            </div>
                            {(state.mode !== OPERATION_MODE.NEW) && (
                                <>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_idEstadoCuenta" className="form-label">Estado de
                                            cuenta</label>
                                        <InputLista
                                            name="cuenta_idEstadoCuenta"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.idEstadoCuenta}
                                            disabled={true}
                                            lista="EstadoCuenta"
                                        />
                                        <FormError />
                                    </div>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_fechaAlta" className="form-label">Fecha alta</label>
                                        <DatePickerCustom
                                            name="cuenta_fechaAlta"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.fechaAlta}
                                            disabled={true}
                                        />
                                        <FormError />
                                    </div>
                                    <div className="col-6 col-md-4 col-lg-2">
                                        <label htmlFor="cuenta_fechaBaja" className="form-label">Fecha baja</label>
                                        <DatePickerCustom
                                            name="cuenta_fechaBaja"
                                            placeholder=""
                                            className="form-control"
                                            value={state.entity.cuenta.fechaBaja}
                                            disabled={true}
                                        />
                                        <FormError />
                                    </div>
                                </>
                            )}
                            <div className="col-6 col-md-4 col-lg-2">
                                <FormLabel htmlFor="cementerio_idTipoPrestador" required={state.mode === OPERATION_MODE.NEW}>Tipo cuenta</FormLabel>
                                <InputLista
                                    name="cementerio_idTipoPrestador"
                                    placeholder=""
                                    className={`form-control ${errorOf('idTipoPrestador') ? 'is-invalid' : ''}`}
                                    value={cementerio_formValues.idTipoPrestador}
                                    onChange={cementerio_formHandleProxy}
                                    disabled={state.mode !== OPERATION_MODE.NEW}
                                    lista="TipoPrestadorCementerio"
                                />
                                <FormError message={errorOf('idTipoPrestador')} />
                            </div>
                            {(state.mode !== OPERATION_MODE.NEW) && (
                                <div className="col-12 col-md-3 col-lg-2">
                                    <FormLabel htmlFor="idCementerioInstitucion" required={state.mode === OPERATION_MODE.EDIT}>Cementerio</FormLabel>
                                    <InputLista
                                        name="idCementerioInstitucion"
                                        placeholder=""
                                        className={`form-control ${errorOf('idCementerioInstitucion') ? 'is-invalid' : ''}`}
                                        value={cementerio_formValues.idCementerioInstitucion}
                                        onChange={cementerio_formHandleProxy}
                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                        title="Cementerio"
                                        lista="Cementerio"
                                    />
                                    <FormError message={errorOf('idCementerioInstitucion')} />
                                </div>
                            )}
                        </div>
                    </Accordion>

                    {(state.mode !== OPERATION_MODE.NEW) && (
                        <>
                            <div className="m-top-20">
                                <Accordion title="Personas vinculadas">
                                    <VinculosCementerioGrid
                                        processKey={state.processKey}
                                        disabled={state.mode === OPERATION_MODE.VIEW || !canEditPersonasVinculadas}
                                        data={{
                                            idCementerio: state.id,
                                            list: state.entity.vinculosCementerio
                                        }}
                                        onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                    />
                                </Accordion>
                            </div>

                            <div className="m-top-20">
                                <Accordion title="Domicilios">
                                    <DomiciliosGrid
                                        data={{
                                            list: domicilios
                                        }}
                                    />
                                </Accordion>
                            </div>

                            {cementerio_formValues.idTipoPrestador === 380 &&
                                <>
                                    <div className="m-top-20">
                                        <Accordion title="Tipo sepultura" open={sepulturaOpen} onToggle={setSepulturaOpen}>
                                            <div className='row form-basic'>
                                                <div className="col-12 col-md-3">
                                                    <FormLabel htmlFor="idTipoConstruccionFuneraria" required={state.mode === OPERATION_MODE.EDIT}>Tipo sepultura</FormLabel>
                                                    <InputEntidad
                                                        name="idTipoConstruccionFuneraria"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.TIPO_CONSTRUCCION_FUNERARIA_MODAL}
                                                        className={`form-control ${errorOf('idTipoConstruccionFuneraria') ? 'is-invalid' : ''}`}
                                                        value={cementerio_formValues.idTipoConstruccionFuneraria}
                                                        onUpdate={({target}) => {
                                                            const data = target.row;
                                                            const codigo = (data) ? data.codigo : '';
                                                            const tieneUbicacion = (data) ? data.tieneUbicacion : false;
                                                            const tieneSuperficie = (data) ? data.tieneSuperficie : false;

                                                            setTipoConstruccionFuneraria({
                                                                codigo: codigo,
                                                                tieneUbicacion: tieneUbicacion,
                                                                tieneSuperficie: tieneSuperficie
                                                            });
                                                        }}
                                                        onChange={cementerio_formHandleProxy}
                                                        disabled={state.mode === OPERATION_MODE.VIEW || (state.entity.elementos.some(x => x.state !== 'r'))}
                                                        title="Tipo sepultura"
                                                        entidad="TipoConstruccionFuneraria"
                                                    />
                                                    <FormError message={errorOf('idTipoConstruccionFuneraria')} />
                                                </div>

                                                <div className="col-6 col-md-4 col-lg-2">
                                                    <FormLabel htmlFor="fechaAlta" required={state.mode === OPERATION_MODE.EDIT}>Fecha alta</FormLabel>
                                                    <DatePickerCustom
                                                        name="fechaAlta"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('fechaAlta') ? 'is-invalid' : ''}`}
                                                        value={cementerio_formValues.fechaAlta}
                                                        onChange={cementerio_formHandleProxy}
                                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                                    />
                                                    <FormError message={errorOf('fechaAlta')} />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-2">
                                                    <label htmlFor="fechaBaja" className="form-label">Fecha baja</label>
                                                    <DatePickerCustom
                                                        name="fechaBaja"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('fechaBaja') ? 'is-invalid' : ''}`}
                                                        value={cementerio_formValues.fechaBaja}
                                                        onChange={cementerio_formHandleProxy}
                                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                                        minValue={cementerio_formValues.fechaAlta}
                                                    />
                                                    <FormError message={errorOf('fechaBaja')} />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-2">
                                                    <label htmlFor="fechaPresentacion" className="form-label">Fecha
                                                        presentación</label>
                                                    <DatePickerCustom
                                                        name="fechaPresentacion"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('fechaPresentacion') ? 'is-invalid' : ''}`}
                                                        value={cementerio_formValues.fechaPresentacion}
                                                        onChange={cementerio_formHandleProxy}
                                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                                        maxValue={today}
                                                    />
                                                    <FormError message={errorOf('fechaPresentacion')} />
                                                </div>
                                                <div className="col-6 col-md-4 col-lg-2">
                                                    <label htmlFor="fechaVencimiento" className="form-label">Fecha
                                                        vencimiento</label>
                                                    <DatePickerCustom
                                                        name="fechaVencimiento"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={cementerio_formValues.fechaVencimiento}
                                                        onChange={cementerio_formHandleProxy}
                                                        disabled={state.mode === OPERATION_MODE.VIEW}
                                                    />
                                                    <FormError />
                                                </div>
                                                {tipoConstruccionFuneraria.tieneSuperficie &&
                                                    <>
                                                        <div className="col-6 col-md-4 col-lg-2">
                                                            <label htmlFor="fechaConcesion" className="form-label">Fecha
                                                                concesión</label>
                                                            <DatePickerCustom
                                                                name="fechaConcesion"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={cementerio_formValues.fechaConcesion}
                                                                onChange={cementerio_formHandleProxy}
                                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                            />
                                                            <FormError />
                                                        </div>
                                                        <div className="col-6 col-md-4 col-lg-2 invisible">
                                                            <label htmlFor="fechaEscritura" className="form-label">Fecha
                                                                escritura</label>
                                                            <DatePickerCustom
                                                                name="fechaEscritura"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={cementerio_formValues.fechaEscritura}
                                                                onChange={cementerio_formHandleProxy}
                                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                            />
                                                            <FormError />
                                                        </div>
                                                        <div className="col-6 col-md-4 col-lg-2">
                                                            <label htmlFor="fechaSucesion" className="form-label">Fecha
                                                                sucesión</label>
                                                            <DatePickerCustom
                                                                name="fechaSucesion"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={cementerio_formValues.fechaSucesion}
                                                                onChange={cementerio_formHandleProxy}
                                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                            />
                                                            <FormError />
                                                        </div>
                                                        <div className="col-6 col-md-4 col-lg-2">
                                                            <label htmlFor="libroEscritura" className="form-label">Libro
                                                                escritura</label>
                                                            <input
                                                                name="libroEscritura"
                                                                type="text"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={cementerio_formValues.libroEscritura}
                                                                onChange={({target}) => {
                                                                    if (target.validity.valid) {
                                                                        cementerio_formSet({
                                                                            ...cementerio_formValues,
                                                                            libroEscritura: target.value
                                                                        });
                                                                    }
                                                                }}
                                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                                autoComplete="off"
                                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                                            />
                                                            <FormError />
                                                        </div>
                                                        <div className="col-6 col-md-4 col-lg-2">
                                                            <label htmlFor="folioEscritura" className="form-label">Folio
                                                                escritura</label>
                                                            <input
                                                                name="folioEscritura"
                                                                type="text"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={cementerio_formValues.folioEscritura}
                                                                onChange={({target}) => {
                                                                    if (target.validity.valid) {
                                                                        cementerio_formSet({
                                                                            ...cementerio_formValues,
                                                                            folioEscritura: target.value
                                                                        });
                                                                    }
                                                                }}
                                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                                autoComplete="off"
                                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                                            />
                                                            <FormError />
                                                        </div>
                                                        <div className="col-6 col-md-4 col-lg-2">
                                                            <label htmlFor="numeroSucesion" className="form-label">Número
                                                                sucesión</label>
                                                            <input
                                                                name="numeroSucesion"
                                                                type="text"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={cementerio_formValues.numeroSucesion}
                                                                onChange={({target}) => {
                                                                    if (target.validity.valid) {
                                                                        cementerio_formSet({
                                                                            ...cementerio_formValues,
                                                                            numeroSucesion: target.value
                                                                        });
                                                                    }
                                                                }}
                                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                                autoComplete="off"
                                                                pattern={PATTERNS.onlyNumbersAndLetters}
                                                            />
                                                            <FormError />
                                                        </div>
                                                        <div className="col-6 col-md-4 col-lg-2">
                                                            <FormLabel htmlFor="digitoVerificador" required={state.mode === OPERATION_MODE.EDIT}>Dígito verificador</FormLabel>
                                                            <input
                                                                name="digitoVerificador"
                                                                type="text"
                                                                placeholder=""
                                                                className={`form-control ${errorOf('digitoVerificador') ? 'is-invalid' : ''}`}
                                                                value={cementerio_formValues.digitoVerificador}
                                                                onChange={cementerio_formHandleProxy}
                                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                                autoComplete="off"
                                                            />
                                                            <FormError message={errorOf('digitoVerificador')} />
                                                        </div>
                                                        <div className="col-6 col-md-4 col-lg-2">
                                                            <FormLabel htmlFor="superficie" required={state.mode === OPERATION_MODE.EDIT}>Superficie (m)</FormLabel>
                                                            <InputNumber
                                                                name="superficie"
                                                                placeholder=""
                                                                className={`form-control ${errorOf('superficie') ? 'is-invalid' : ''}`}
                                                                value={cementerio_formValues.superficie}
                                                                precision={2}
                                                                onChange={cementerio_formHandleProxy}
                                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                            />
                                                            <FormError message={errorOf('superficie')} />
                                                        </div>
                                                        <div className="col-6 col-md-4 col-lg-2">
                                                            <FormLabel htmlFor="largo" required={state.mode === OPERATION_MODE.EDIT}>Largo (m)</FormLabel>
                                                            <InputNumber
                                                                name="largo"
                                                                placeholder=""
                                                                className={`form-control ${errorOf('largo') ? 'is-invalid' : ''}`}
                                                                value={cementerio_formValues.largo}
                                                                precision={2}
                                                                onChange={cementerio_formHandleProxy}
                                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                            />
                                                            <FormError message={errorOf('largo')} />
                                                        </div>
                                                        <div className="col-6 col-md-4 col-lg-2">
                                                            <FormLabel htmlFor="ancho" required={state.mode === OPERATION_MODE.EDIT}>Ancho (m)</FormLabel>
                                                            <InputNumber
                                                                name="ancho"
                                                                placeholder=""
                                                                className={`form-control ${errorOf('ancho') ? 'is-invalid' : ''}`}
                                                                value={cementerio_formValues.ancho}
                                                                precision={2}
                                                                onChange={cementerio_formHandleProxy}
                                                                disabled={state.mode === OPERATION_MODE.VIEW}
                                                            />
                                                            <FormError message={errorOf('ancho')} />
                                                        </div>
                                                    </>}
                                            </div>
                                        </Accordion>
                                    </div>
                                    {!isEmptyString(tipoConstruccionFuneraria.codigo) && tipoConstruccionFuneraria.tieneUbicacion &&
                                        ubicacionDefinicion && Array.from({length: 15}, (_, i) => i + 1).some(n => ubicacionDefinicion[`ubicacionDescripcion${n}`]) &&
                                        <div className="m-top-20">
                                            <Accordion title="Ubicación sepultura" open={ubicacionOpen} onToggle={setUbicacionOpen}>
                                                <div className='row form-basic'>
                                                    {Array.from({length: 15}, (_, i) => i + 1)
                                                        .filter(n => ubicacionDefinicion[`ubicacionDescripcion${n}`])
                                                        .map(n => (
                                                            <div key={n} className="col-6 col-md-2">
                                                                <FormLabel htmlFor={`ubicacionValor${n}`} required={state.mode === OPERATION_MODE.EDIT && !!ubicacionDefinicion[`ubicacionObligatorio${n}`]}>
                                                                    {ubicacionDefinicion[`ubicacionDescripcion${n}`]}
                                                                </FormLabel>
                                                                <input
                                                                    name={`ubicacionValor${n}`}
                                                                    type="text"
                                                                    placeholder=""
                                                                    className={`form-control ${errorOf(`ubicacionValor${n}`) ? 'is-invalid' : ''}`}
                                                                    value={cementerio_formValues[`ubicacionValor${n}`]}
                                                                    onChange={({target}) => {
                                                                        if (target.validity.valid) {
                                                                            cementerio_formSet({
                                                                                ...cementerio_formValues,
                                                                                [`ubicacionValor${n}`]: target.value
                                                                            });
                                                                            setPendingChange(true);
                                                                        }
                                                                    }}
                                                                    disabled={state.mode === OPERATION_MODE.VIEW}
                                                                    autoComplete="off"
                                                                    pattern={PATTERNS.onlyNumbersAndLettersWithAccents}
                                                                />
                                                                <FormError message={errorOf(`ubicacionValor${n}`)} />
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </Accordion>
                                        </div>
                                    }

                                    <div className="m-top-20">
                                        <Accordion title="Inhumados">
                                            <InhumadosGrid
                                                processKey={state.processKey}
                                                disabled={state.mode === OPERATION_MODE.VIEW || !canEditInhumados}
                                                data={{
                                                    idCementerio: state.id,
                                                    list: state.entity.inhumados
                                                }}
                                                onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                                            />
                                        </Accordion>
                                    </div>
                                </>
                            }
                            <div className="m-top-20">
                                <Accordion title="Estado" open={estadoOpen} onToggle={setEstadoOpen}>
                                    <div className='row form-basic'>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <FormLabel htmlFor="cementerio_idEstadoCarga" required>Estado de carga</FormLabel>
                                            <InputLista
                                                name="cementerio_idEstadoCarga"
                                                placeholder=""
                                                className={`form-control ${errorOf('idEstadoCarga') ? 'is-invalid' : ''}`}
                                                value={cementerio_formValues.idEstadoCarga}
                                                onChange={cementerio_formHandleProxy}
                                                disabled={state.mode === OPERATION_MODE.VIEW || state.entity.cementerio.idEstadoCarga !== 20}
                                                lista="EstadoCarga"
                                            />
                                            <FormError message={errorOf('idEstadoCarga')} />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <label htmlFor="cementerio_fechaCargaInicio" className="form-label">Fecha
                                                inicio carga</label>
                                            <DatePickerCustom
                                                name="cementerio_fechaCargaInicio"
                                                placeholder=""
                                                className="form-control"
                                                value={state.entity.cementerio.fechaCargaInicio}
                                                disabled={true}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-2">
                                            <label htmlFor="cementerio_fechaCargaFin" className="form-label">Fecha fin
                                                carga</label>
                                            <DatePickerCustom
                                                name="cementerio_fechaCargaFin"
                                                placeholder=""
                                                className="form-control"
                                                value={state.entity.cementerio.fechaCargaFin}
                                                disabled={true}
                                            />
                                            <FormError />
                                        </div>
                                        <div className="col-6 col-md-3 col-lg-3 col-xl-6">
                                            {state.mode === OPERATION_MODE.EDIT && state.entity.cuenta.idEstadoCuenta === CUENTA_STATE.ACTIVA &&
                                                <button className="btn action-button float-end m-top-30"
                                                        onClick={(event) => handleClickBaja()}>Baja</button>
                                            }
                                        </div>
                                    </div>
                                </Accordion>
                            </div>

                            {cementerio_formValues.idTipoPrestador === PRESTADOR_CEMENTERIO_TYPE.PRESTADOR_SERVICIOS &&
                                <div className="m-top-20">
                                    <Accordion title="Elementos">
                                        <ElementosTab {...{state, UpdateEntity}} />
                                    </Accordion>
                                </div>
                            }

                            <div className="m-top-20">
                                <Accordion title="Información adicional">
                                    <DataTaggerFormRedux
                                        title="Información adicional de Cementerio"
                                        processKey={state.processKey}
                                        entidad="Cementerio"
                                        idEntidad={state.id}
                                        disabled={(state.mode === OPERATION_MODE.VIEW)}
                                        onChange={(row) => setPendingChange(true)}
                                    />
                                </Accordion>
                            </div>

                            <TabsForm
                                state={state}
                                SetTabActive={SetTabActive}
                                UpdateEntity={UpdateEntity}
                                pendingChange={pendingChange}
                                refetchCementerio={refetchCementerio}
                            />

                        </>
                    )}

                </div>

            </section>
        </>
    )
}

export default SectionForm

